export default __webpack_public_path__ + "static/media/background-image.6516f996.svg";